<template>
    <div class="contest">
        <v-container class="custom-container">
            <v-row dense>
                <v-col cols="12">
                    <v-card class="pa-5 pb-0" elevation="0" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
                        <v-row dense>
                            <v-col cols="12" sm="6" md="7" lg="7">
                                <v-card class="elevation-0 px-5 py-3 rounded-0 running-content"
                                    :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
                                    <v-card-actions class="title custom-border-bottom">
                                        <h3>Leaderboard</h3>
                                        <p>Total Contestant : <span>{{ runningcontest?.total_contestants || 0 }}</span>
                                        </p>
                                    </v-card-actions>
                                    <v-card-actions class="title custom-border-bottom">
                                        <h4>Running Contest</h4>
                                        <div class="text-right">
                                            <p>Finishing Timer </p>
                                            <timer-view :timer="runningcontest"></timer-view>
                                        </div>
                                    </v-card-actions>
                                </v-card>
                                <running-data-table :participants="runningcontest.participants"></running-data-table>
                            </v-col>
                            <v-col cols="12" sm="6" md="5" lg="5">
                                <running-contest-card :contest="runningcontest"></running-contest-card>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import AddContestModal from '@/components/Contest/AddContestModal.vue';
import ContestCard from '@/components/Contest/ContestCard.vue';
import RunningContestCard from '@/components/Contest/RunningContestCard.vue';
import RunningDataTable from '@/components/Contest/RunningDataTable.vue';
import TimerView from '@/components/Contest/TimerView.vue';
import { CONTEST__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
    components: { AddContestModal, ContestCard, TimerView, RunningContestCard, RunningDataTable },
    computed: {
        ...mapState("contest", ["runningcontest"]),
    },
    methods: {
        ...mapActions("contest", [CONTEST__ACTIONS.VIEWRUNNINGCONTEST]),
    },
    async mounted() {
        this[CONTEST__ACTIONS.VIEWRUNNINGCONTEST](this.$route.query.id);
    }
}
</script>
